<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <v-card-text>
        <span v-if='!estimate.customer_notes'>None...</span>
        <span v-html='estimate.customer_notes'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-alert type='error' border='left'>The customer will see these notes so be professional!</v-alert>
      <v-textarea outlined auto-grow v-model='estimateCopy.customer_notes'></v-textarea>
    </wc-dialog>

    <wc-confirm
      title='Copy to Field Instructions?'
      :showDialog='showCopyToField'
      cancelText="No, Don't Copy"
      saveText='Yes,Copy'
      @cancel='noCopySave'
      @confirm='copySave'
    >
      Do you want to copy the customer notes to the field instructions?<br>
      <br>
      This will replace all notes in the Field Instructions section with the notes in the Customer Notes section.
    </wc-confirm>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'customer-instrucions',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    showCopyToField: false,
    title: 'Customer Instructions',
    icon: 'mdi-text-box',
    iconColor: 'pink',
    estimateCopy: [],
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showDialog = true
    },
    saveChanges () {
      this.showCopyToField = true
      // if (!this.estimateCopy.field_instructions) {
      //   this.estimateCopy.field_instructions = this.estimateCopy.customer_notes
      // }
      // this.$emit('update', this.estimateCopy)
      // this.showDialog = false
    },
    copySave () {
      this.estimateCopy.field_instructions = this.estimateCopy.customer_notes
      this.$emit('update', this.estimateCopy)
      this.showCopyToField = false
      this.showDialog = false
    },
    noCopySave () {
      this.$emit('update', this.estimateCopy)
      this.showCopyToField = false
      this.showDialog = false
    }
  }
}
</script>
